let isConfigured = false;

export function configureGptOnce({
  enableGpc = false,
  privacy = {},
  setForceSafeFrame = false,
  limitedAds = false,
} = {}) {
  if (typeof window === 'undefined') {
    return;
  }

  window.googletag = window.googletag || {};
  window.googletag.cmd = window.googletag.cmd || [];

  if (isConfigured) {
    return;
  }

  isConfigured = true;

  window.googletag.cmd.push(() => {
    if (setForceSafeFrame) {
      window.googletag.pubads().setForceSafeFrame(true);
    }

    window.googletag.pubads().disableInitialLoad();
    window.googletag.pubads().enableSingleRequest();
    window.googletag.pubads().collapseEmptyDivs(true);

    if (enableGpc) {
      window.googletag.pubads().setPrivacySettings({
        restrictDataProcessing: Boolean(privacy?.doNotSell),
        us_privacy: privacy?.uspString,
        limitedAds: Boolean(limitedAds),
      });
    }
  });
}
